export default __webpack_public_path__ + "static/media/012-line-red.4c95c305.svg";